import React, { useRef } from 'react';
import { useWizard } from 'react-use-wizard';
import { AnimatePresence, motion } from 'framer-motion';
export default function AnimatedWrapper(_ref) {
  let {
    children,
    stepsCount,
    NavigationContext
  } = _ref;
  const {
    activeStep
  } = useWizard();
  const navigationDirection = useRef(1); // 1 for forward, -1 for backward
  const motionRef = useRef(null);
  const variants = {
    enter: () => ({
      x: navigationDirection.current > 0 ? 800 : -800,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: () => {
      const direction = navigationDirection.current;
      return {
        x: direction < 0 ? 800 : -800,
        opacity: 0
      };
    }
  };
  return /*#__PURE__*/React.createElement(NavigationContext.Provider, {
    value: navigationDirection
  }, /*#__PURE__*/React.createElement(AnimatePresence, {
    mode: "wait",
    initial: false
  }, /*#__PURE__*/React.createElement(motion.div, {
    key: activeStep,
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit",
    ref: motionRef,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30
    }
  }, children)));
}